import React, {useState, useCallback} from 'react';
import {TouchableOpacityProps} from './props';

const TouchableOpacity: React.FC<TouchableOpacityProps> = ({
  children,
  onPress,
  activeOpacity = 0.8,
  disabled = false,
  style,
  className = '',
}) => {
  const [isPressed, setIsPressed] = useState(false);

  const handleClick = useCallback(() => {
    if (disabled) return;
    onPress?.();
  }, [disabled, onPress]);

  return (
    <div
      className={`
        select-none transition-opacity duration-150 ease-in-out
        ${disabled ? 'cursor-default opacity-60' : 'cursor-pointer'}
        ${className}
      `}
      style={{
        opacity: isPressed ? activeOpacity : undefined,
        ...style,
      }}
      onMouseDown={() => !disabled && setIsPressed(true)}
      onMouseUp={() => !disabled && setIsPressed(false)}
      onMouseLeave={() => !disabled && setIsPressed(false)}
      onTouchStart={() => !disabled && setIsPressed(true)}
      onTouchEnd={() => !disabled && setIsPressed(false)}
      onClick={handleClick}
      role="button"
      tabIndex={disabled ? -1 : 0}>
      {children}
    </div>
  );
};

export default TouchableOpacity;
